import { render, staticRenderFns } from "./StorageTariff.vue?vue&type=template&id=5799b03b"
import script from "./StorageTariff.vue?vue&type=script&lang=js"
export * from "./StorageTariff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports